import _ from 'lodash';
import { adminClient as apolloClient } from '@/store/apollo';

import BlueprintsGql from '@/store/graphql/cms/queries/Blueprints.gql';
import ExtensionsGql from '@/store/graphql/cms/queries/Extensions.gql';
import TemplatesGql from '@/store/graphql/system/queries/Templates.gql';
import BillingFeaturesGql from '@/store/graphql/billing/queries/BillingFeatures.gql';
import BillingTaxRateGql from '@/store/graphql/billing/queries/BillingTaxRate.gql';
import BusinessCardCategoriesGql from '@/store/graphql/cms/queries/BusinessCardCategories.gql';
import BusinessCardTagsGql from '@/store/graphql/cms/queries/BusinessCardTags.gql';
import CheckSubdomainAvailabilityGql from '@/store/graphql/cms/queries/CheckSubdomainAvailability.gql';
import CheckUserEmailAvailabilityGql from '@/store/graphql/system/queries/CheckUserEmailAvailability.gql';
import SearchOwnersGql from '@/store/graphql/cms/queries/SearchOwners.gql';
import AttachableShopsGql from '@/store/graphql/shop/queries/AttachableShops.gql';
import InitializeCmsGql from '@/store/graphql/cms/mutations/InitializeCms.gql';
import UpdateCmsFromWizardGql from '@/store/graphql/cms/mutations/UpdateCmsFromWizard.gql';
import CreateWizardStripeSetupIntentGql from '@/store/graphql/billing/mutations/CreateWizardStripeSetupIntent.gql';

export default {
    fetchBlueprints: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: BlueprintsGql,
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.CP_Blueprints))
                .catch(err => reject(err));
        }),

    fetchExtensions: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: ExtensionsGql,
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.CP_Extensions))
                .catch(err => reject(err));
        }),

    fetchBillingFeatures: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: BillingFeaturesGql,
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.BillingFeatures))
                .catch(err => reject(err));
        }),

    fetchBillingTaxRate: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: BillingTaxRateGql,
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.BillingTaxRate))
                .catch(err => reject(err));
        }),

    fetchBusinessCardCategories: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: BusinessCardCategoriesGql,
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.CP_BusinessCardCategories))
                .catch(err => reject(err));
        }),

    fetchBusinessCardTags: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: BusinessCardTagsGql,
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.CP_BusinessCardTags))
                .catch(err => reject(err));
        }),

    fetchTemplates: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: TemplatesGql,
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.CP_Templates))
                .catch(err => reject(err));
        }),

    checkSubdomainAvailability: (subdomain) =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: CheckSubdomainAvailabilityGql,
                    variables: { subdomain },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.CP_CheckSubdomainAvailability))
                .catch(err => reject(err));
        }),

    checkUserEmailAvailability: (email) =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: CheckUserEmailAvailabilityGql,
                    variables: { email },
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.CheckUserEmailAvailability))
                .catch(err => reject(err));
        }),

    searchOwners: (search, options) =>
        new Promise((resolve, reject) => {
            const filters = [];

            if (search) {
                filters.push({ key: 'name', like: search });
            }

            if (options && options.unverifiedOnly) {
                filters.push({ key: 'email_verified', match: '0' });
            }

            apolloClient
                .query({
                    query: SearchOwnersGql,
                    variables: { filters: filters, order: 'id', direction: 'desc' },
                    fetchPolicy: 'no-cache'
                })
                .then(({ data }) => {
                    const users = _.get(data, 'UsersPaginated.items', []);
                    // Transform to dropdown options format
                    const options = users.map(user => ({
                        id: user.id,
                        label: user.name || [user.first_name, user.last_name].filter(Boolean).join(' ') || user.email,
                        email: user.email,
                        company: user.company
                    }));
                    resolve(options);
                })
                .catch(err => reject(err));
        }),

    fetchAttachableShops: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .query({
                    query: AttachableShopsGql,
                    fetchPolicy: 'network-only'
                })
                .then(({ data }) => resolve(data.CO_Shops))
                .catch(err => reject(err));
        }),

    initializeCms: (variables) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: InitializeCmsGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_InitializeCms))
                .catch(err => reject(err));
        }),

    updateCmsFromWizard: (variables) =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: UpdateCmsFromWizardGql,
                    variables
                })
                .then(({ data }) => resolve(data.CP_UpdateCmsFromWizard))
                .catch(err => reject(err));
        }),

    createWizardStripeSetupIntent: () =>
        new Promise((resolve, reject) => {
            apolloClient
                .mutate({
                    mutation: CreateWizardStripeSetupIntentGql
                })
                .then(({ data }) => resolve(data.CreateWizardStripeSetupIntent))
                .catch(err => reject(err));
        })
};
